class CartCount extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged (e) {
    const { state } = e.detail
    if (!state) return
    if (!('push-cart-count' in state?.sections)) return
    let target = this
    if (this.els.CartCountText) target = this.els.CartCountText.element

    const count = this.getCount(state.sections['push-cart-count'])
    target.textContent = count

    // On mobile, counts with 3+ characters will overflow the icon, so hide them
    this.setAttribute('aria-hidden', count < 1 && window.innerWidth < 1201)
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html)

    return DOM.querySelector('#push-cart-count').textContent
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount)
}
